 /* ===========================================================
 * 
 *   Insights Controller
 * 
 *   Custom functionality and Ajax Load More listeners
 *   for the Insights Landing Page. 
 * 
 *   Requires: jQuery
 * 
 * ===========================================================*/


$(function() {

    String.prototype.safeCSSId = function() {
    return encodeURIComponent(
        this.toLowerCase()
        ).replace(/%[0-9A-F]{2}/gi,'');
    }

    /**
     * Onload, add the markup and listeners
     * to the ALM filters
     */
    var initFilters = function() {

        $('.alm-filter--title').on('click', function(){
            $(this).parent().toggleClass('open');
        });

        $(document).on('click', '.alm-filter--all', function(){
            var filterParent = $(this).closest('.alm-filter');
            $('.alm-filter--link.active', filterParent).trigger('click');
        });
    
        $('.alm-filter ul').each(function(){

            if ($(this).parent().hasClass('alm-filter--author')) {
                $(this).prepend('<li class="alm-filter--all"><div class="alm-filter--link-all">Everyone</div></li>');
            }

            else {
                $(this).prepend('<li class="alm-filter--all"><div class="alm-filter--link-all">Everything</div></li>');
            }
        });

        $('.alm-filter ul').each(function(){
            $(this).prepend('<span class="alm-filter--close"></span>');
        });

        $('.alm-filter--title').each(function(){
            $(this).append('<div class="alm-filter--current-outer"><div class="alm-filter--current"></div></div>');
        })
    };


    /**
     * On change, show the current selected
     * filter options
     */
    var updateFilters = function() {

        var filtersActive = false;

        $('.alm-filter').each(function(){
            
            var filterActive = false;

            if ($(this).hasClass('alm-filter--author')) {
                filterDesc = 'Everyone';
                filterClass = 'everyone';
            }

            else {
                filterDesc = 'Everything';
                filterClass = 'everything';
            }
            
            currentOption =  $('.alm-filter--link.active', this).text();

            if (currentOption) {
                filterDesc = currentOption;
                filterClass = currentOption.safeCSSId();
                filterActive = true;
                filtersActive = true;
            }

            $('.alm-filter--current', $(this)).attr('data-current', '');
            $('.alm-filter--current', $(this)).html( filterDesc );
            $('.alm-filter--current', $(this)).attr( 'data-current', filterClass );

            $(this).removeClass('open');

            if (filterActive) {
                $(this).addClass('filteractive');
            }

            else {
                $(this).removeClass('filteractive');
            }
        });

        if (filtersActive) {
            $('.clear-filter').css('visibility', 'visible');
        }

        setTimeout( function(){
            responsiveBackgroundImages();
        }, 1000 );

        responsiveBackgroundImages();
        $(window).trigger('resize');

        setTimeout( function() {
            $(window).trigger('resize');
        }, 1000 );

        setTimeout( function() {
            $(window).trigger('resize');
        }, 3000 );

        //  Perpetutal monitoring
        setInterval( equalHeight, 200 );

        //  On resize, re-evaluate the heights
        $(window).resize( equalHeight );

    };

    /**
     * Make sure the height of the main content is as
     * tall as the sidebar(s)
     */
    var equalHeight = function(){
        
        //  Only worry about this when we *have* sidebars
        if ($(window).width() > 1024) {

            //  Empty main height
            $_main_height = null;

            //  Sidebar, filter height
            $_sidebar_height = $('.widget-area.sidebar').height() + 286;
            $_filter_height = $('.widget-area.sidebar').height() + 286;

            //  Choose the larger of the two
            $_main_height = $_sidebar_height > $_filter_height ? $_sidebar_height : $_filter_height;

            //  Set the main height
            $('.site-main').css('min-height', $_main_height + 'px');
        }

        //  If no sidebars, unset the main height
        else {
            $('.site-main').css('min-height', 'none');
        }
    };

    /**
     * Onchange, scroll to the top of the list
     * 
     * @param {event} e
     * 
     */
    var scrollToTop = function(alm) {
        
        $('html, body').animate({
            scrollTop: $(".page-banner").offset().top
        }, 500);
            
    };


    /**
     * Init the listeners
     */
    var init = function(){
        window.almComplete = function(alm){
            updateFilters();
        };

        window.almFilterComplete = function(alm) {
            updateFilters();
        }

        window.almUrlUpdate = function(alm) {
            updateFilters();
        }

        window.almOnChange = function(alm) {
            updateFilters();
            scrollToTop();
        }

        window.almEmpty = function(alm){
        };
        window.almPagingInit = function(alm) {
            
        }

        initFilters();
        updateFilters();


        $(document).on( 'click', '.alm-filter--close', function(){
            $(this).closest('.alm-filter.open').removeClass('open');
        });
    }

    /**
     * Start the controller
     */
    init();
});
